import tw, { styled } from 'twin.macro';

export const ManualEntryPromptText = styled.p`
  ${tw`text-center text-sm w-full`}
  color: #858591;
`;

export const ManualEntryPromptLink = styled.span`
  ${tw`underline cursor-pointer font-medium`}
  color: #666676;
`;

export const ManualEntryBody = styled.div`
  ${tw`flex flex-col flex-1 w-full items-start`}
  padding: 24px 40px 40px;
  gap: 24px;
`;

export const ManualFieldWrapper = styled.div`
  ${tw`flex flex-col w-full`}
  gap: 8px;
`;

export const ManualFieldLabel = styled.label`
  ${tw`m-0`}
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.21em;
  color: #1c1c33;
`;
